import { Spin } from "../../components/standardization/YuJaLoading";
import "antd/dist/antd.min.css";
import React from "react";
import { Form, Modal } from "react-bootstrap";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { EXPORT_GRADEBOOK_FIRST_WARNING, EXPORT_GRADEBOOK_SECOND_WARNING, EXPORT_GRADEBOOK_WARNING_SUBTEXT, EXPORT_GRADEBOOK_WARNING_TEXT, EXPORT_GRADEBOOK_WARNING_TITLE, MODAL_CLOSE_TEXT } from "../../utils/constants";
import "./modal.css";
import YuJaButton from "../standardization/YuJaButton";

export default function GradebookWarningModal({show, setModalShow, handleExportFromModal}) {
    const isLoading = false;

    const handleClose = () =>{
        setModalShow(false)
        modalConfig.clearForm();
    };

    const clearForm = () => {
        setModalShow(false);
    }

    const modalConfig = {
        title: EXPORT_GRADEBOOK_WARNING_TITLE,
        submitButtonText: "Export Anyways",
        clearForm: clearForm,
        submit: handleExportFromModal,

        form: [
            {
                label: EXPORT_GRADEBOOK_WARNING_TEXT,
                sub_label_first: EXPORT_GRADEBOOK_FIRST_WARNING, 
                sub_label_second: EXPORT_GRADEBOOK_SECOND_WARNING, 
                isMulti: false,
                type: "warning",
            },
        ],
    };

    return (
    <Modal
      id="form-modal"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      backdrop={isLoading ? "static" : true}
    >
        <Spin tip="Loading..." size="large" spinning={isLoading}>
            <ModalClose onClick={handleClose} className="modal-close" />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title
                    className="warning-title"
                    id="contained-modal-title-vcenter"
                >
                    {modalConfig.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="customized-form" onSubmit={e => e.preventDefault()}>
                    {modalConfig.form.map((formItem, idx) => {
                        return (
                            <Form.Group style={{ marginBottom: "0.938rem" }} key={idx}>
                                <div className="form-check-label">{formItem.label}</div>

                                <div className="form-check-label" style={{marginTop: "20px"}}>{formItem.sub_label_first}</div>

                                <div className="form-check-label" style={{marginTop: "20px"}}>{formItem.sub_label_second}</div>
                            </Form.Group>
                        );
                    })}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton onClick={handleClose} type={"secondary"}>
                    {MODAL_CLOSE_TEXT}
                </YuJaButton>
                <YuJaButton
                    onClick={(e) => {
                    e.preventDefault();
                        modalConfig.submit();
                    }}
                >
                    {modalConfig.submitButtonText}
                </YuJaButton>
            </Modal.Footer>
        </Spin>
    </Modal>)
}
